import React from "react";
import { ScrollText, Flame, Trophy } from "lucide-react";

const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
  } catch {
    return iso;
  }
};

export default function HistoryLog({ history }) {
  return (
    <div data-testid="history-log" className="space-y-2">
      <div className="text-[10px] uppercase tracking-[0.3em] text-blue-400/80 flex items-center gap-1.5">
        <ScrollText className="h-3 w-3" /> // Quest Log · Last 60 Days
      </div>
      {history.length === 0 ? (
        <div className="border border-dashed border-white/10 text-center py-12 text-slate-500 text-sm">
          The System has no records yet. Complete a day to begin your saga.
        </div>
      ) : (
        <ul className="space-y-2 max-h-[480px] overflow-y-auto pr-1">
          {history.map((h, i) => (
            <li
              key={`${h.date}-${i}`}
              className="border border-white/10 bg-black/30 p-3 flex items-start gap-3 hover:border-blue-500/40 transition"
              data-testid={`history-entry-${h.date}`}
            >
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 w-24 shrink-0 pt-0.5">
                {formatDate(h.date)}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm text-white font-display uppercase tracking-wide truncate">
                  {h.questsCount} quests cleared
                </div>
                <div className="text-[11px] text-slate-500 truncate font-mono">
                  {h.questTitles?.join(" · ") || ""}
                </div>
              </div>
              <div className="text-right shrink-0">
                <div className="font-mono text-amber-300 text-sm">+{h.xp} XP</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 flex items-center justify-end gap-1">
                  <Trophy className="h-3 w-3 text-blue-400" /> LV {h.level} ·{" "}
                  <span className="text-purple-300">{h.rank}</span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
